"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.InternalTag = void 0;
var InternalTag;
(function (InternalTag) {
    InternalTag["earliest"] = "earliest";
    InternalTag["latest"] = "latest";
    InternalTag["pending"] = "pending";
})(InternalTag = exports.InternalTag || (exports.InternalTag = {}));
var Tag;
(function (Tag) {
    Tag.latest = "latest";
    Tag.earliest = "earliest";
    Tag.pending = "pending";
})(Tag = exports.Tag || (exports.Tag = {}));
//# sourceMappingURL=tags.js.map